import { render, staticRenderFns } from "./KidsProductPrices.vue?vue&type=template&id=3e7b2ada&scoped=true&"
import script from "./KidsProductPrices.vue?vue&type=script&lang=js&"
export * from "./KidsProductPrices.vue?vue&type=script&lang=js&"
import style0 from "./KidsProductPrices.vue?vue&type=style&index=0&id=3e7b2ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7b2ada",
  null
  
)

export default component.exports